module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClaimStep2"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "loading",
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "main",
    staticStyle: {
      "padding-bottom": "50px"
    }
  }, [_c('p', {
    staticClass: "doc_title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("如果您的资金不幸被盗，请按以下步骤进行索赔登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_text"
  }, [_vm._v("1.手持身份证拍照（正反面）")]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item item1"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoIdCardEvidenceFront),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoIdCardEvidenceFront", $$v)
      },
      expression: "formData.photoIdCardEvidenceFront"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "item item2"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "dest": "wifikey",
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoIdCardEvidenceReverse),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoIdCardEvidenceReverse", $$v)
      },
      expression: "formData.photoIdCardEvidenceReverse"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "doc_text",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("2.被盗信息截屏")]), _vm._v(" "), _c('div', {
    staticClass: "upload"
  }, [_c('div', {
    staticClass: "item screenShot"
  }, [_c('wk-single-image-upload', {
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "change": _vm.getIdCardFront
    },
    model: {
      value: (_vm.formData.photoStolenEvidence),
      callback: function($$v) {
        _vm.$set(_vm.formData, "photoStolenEvidence", $$v)
      },
      expression: "formData.photoStolenEvidence"
    }
  }, [_c('solt', {
    staticClass: "loading",
    attrs: {
      "name": "loading"
    }
  })], 1), _vm._v(" "), _c('button', [_vm._v("上传照片")]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_vm._v("已上传")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "button",
    staticStyle: {
      "margin-top": "25px"
    },
    on: {
      "click": _vm.claimStep2
    }
  }, [_vm._v("确认登记")]), _vm._v(" "), _c('p', {
    staticClass: "doc_a",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/new/claimFlow"
    }
  }, [_vm._v("了解索赔流程")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "model"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "title"
  }), _vm._v(" "), _c('p', {
    staticClass: "content"
  }), _vm._v(" "), _c('p', {
    staticClass: "foot"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "loading"
    }
  }, [_c('div', {
    staticClass: "circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad0c8928"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/claimStep2.vue
// module id = 843
// module chunks = 1